<template>
  <div class="contentBox">
    <!-- 头部滚动信息 -->
    <div class="infoContent">
      <img src="../../assets/images/h5Img/icon.png" alt="" />
      <!-- 滚动信息 -->
      <div class="infoList" id="infoList">
        <ul class="contentBox1" id="contentBox1">
          <li v-for="item in infoListData">
            <span>{{ item }}</span> &nbsp;
          </li>
        </ul>
        <ul class="contentBox1" id="contentBox2"></ul>
      </div>
    </div>

    <!-- banner Box -->
    <div class="headBanner">
      <img src="../../assets/images/h5Img/headBanner.png" alt="" />
    </div>
    <h3 class="title">Regístrate en estos momentos y recibirás premios</h3>
    <!-- content main box -->
    <div class="contentBIgBox">
      <!-- register Box -->
      <form class="registerBox" id="test">
        <van-field
          v-model="loginUser"
          type="digit"
          label="+51  |"
          clearable
          maxlength="9"
          placeholder="Ingrese el número de teléfono"
          style="margin-bottom: 0.15rem;"
        />
        <van-field
          v-model="auth_code"
          type="digit"
          clearable
          maxlength="4"
          placeholder="Ingrese el código de verificación"
        >
          <template #button>
            <van-button
              class="codeBtn"
              size="small"
              type="primary"
              @click="sendCode"
              :disabled="btnDisabled"
              :style="{ color: btnDisabled ? '#333' : '#fff' }"
            >
              {{ !btnDisabled ? "Obtener" : countDown + "s" }}
            </van-button>
          </template>
        </van-field>
        <img
          @click="submitRegister"
          class="subImg"
          src="../../assets/images/h5Img/subBtn.png"
          alt=""
        />
      </form>

      <video
        class="videoBox"
        controls
        src="../../assets/webImg/rightVideo.mp4"
      ></video>

      <!-- plataforma -->
      <div class="plataformaBox">
        <div class="titleImg">Ventajas de la plataforma</div>
        <ul>
          <li v-for="item in plataformList">
            <img src="../../assets/images/h5Img/listIcon.png" alt="" />
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>

      <!-- datos plataforma -->
      <div class="datosPlataforma">
        <div class="titleImg">Datos de la plataforma</div>
        <ul>
          <li>
            El número de usuarios registrados en nuestra base de datos, supera
            los 500,000
          </li>
          <li>
            El monto de los préstamos acumulados del préstamo superó los 128
            millones hasta la actualidad
          </li>
          <li>
            Nuestra plataforma lleva más de 2 años funcionando
          </li>
          <li>
            Pérdida de datos del usuario al utilizar la plataforma
          </li>
        </ul>
      </div>

      <!-- concat Box -->
      <div class="concatBox">
        <div class="titleImg">Contáctenos</div>
        <ul>
          <li @click="openApp(1, '960603592')">
            <div>
              <img src="../../assets/images/h5Img/whatsapp.png" alt="" />
              WhatsApp
            </div>
            <p>+51 960603592</p>
          </li>
          <li @click="openApp(2, '929659529')">
            <div>
              <img src="../../assets/images/h5Img/phone.png" alt="" />
              Servicio al Cliente
            </div>
            <p>+51 929659529</p>
          </li>
          <li
            v-clipboard:copy="'gilbert.reid3491@outlook.com'"
            v-clipboard:success="onCopy"
          >
            <div>
              <img src="../../assets/images/h5Img/email.png" alt="" />
              Correo
            </div>
            <p>gilbert.reid3491@outlook.com</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getCode, login } from "../../utils/api/h5page.js";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      infoListData: [
        "Usuario ***156*** acaba de recibir la cantidad de S/1,500",
        "Usuario ***285*** acaba de recibir la cantidad de S/3,200",
        "Usuario ***184*** acaba de recibir la cantidad de S/1,550",
        "Usuario ***863*** acaba de recibir la cantidad de S/2,700",
        "Usuario ***936*** acaba de recibir la cantidad de S/4,000",
        "Usuario ***032*** acaba de recibir la cantidad de S/1,400",
        "Usuario ***174*** acaba de recibir la cantidad de S/2,550",
        "Usuario ***294*** acaba de recibir la cantidad de S/3,500",
        "Usuario ***113*** acaba de recibir la cantidad de S/1,800",
        "Usuario ***772*** acaba de recibir la cantidad de S/3,900",
        "Usuario ***425*** acaba de recibir la cantidad de S/2,400",
        "Usuario ***153*** acaba de recibir la cantidad de S/5,000",
        "Usuario ***634*** acaba de recibir la cantidad de S/3,200",
        "Usuario ***126*** acaba de recibir la cantidad de S/2,100",
        "Usuario ***010*** acaba de recibir la cantidad de S/3,700",
        "Usuario ***983*** acaba de recibir la cantidad de S/2,500",
        "Usuario ***198*** acaba de recibir la cantidad de S/3,200",
      ],
      loginUser: "",
      auth_code: "",
      countDown: 60,
      countInterval: null,
      btnDisabled: false,
      plataformList: [
        "¡El nivel de aprobación es el más optimo que hace que sea más fácil obtener un préstamo!",
        "Plataforma de préstamos de límite de monto de préstamo alto, puede alcanzar el límite máximo",
        "El plazo de tiempo es el más largo, hasta 91 días (incluida la renovación) -180 días (incluida la renovación)",
        "Plataforma de préstamos totalmente segura, toda la información está cifrada y almacenada",
        "Menor interés, las 100 primeras personas podrán disfrutar del beneficio sin intereses",
        "El préstamo se recibe de forma rápida , en tan solo 3 minutos",
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    console.log("[ navigator.userAgent ] >", navigator.userAgent);
    window.localStorage.setItem("channel", this.$route.query.channel);
    this.scrollInfo();
    // 动态创建script标签加载CDN资源
    const script = document.createElement("script");
    script.src =
      "https://track.yingliangads.com/track.js?pid=35&u1=21&u2=&u3=&u4=&pt=fb&id=882877243436767";
    script.onload = () => {
      // 资源加载完毕后的回调
      console.log("Lodash is loaded!");
    };
    document.head.appendChild(script);
  },
  methods: {
    // 信息效果
    scrollInfo() {
      const content = document.getElementById("infoList");
      const msg1 = document.getElementById("contentBox1");
      const msg2 = document.getElementById("contentBox2");
      msg2.innerHTML = msg1.innerHTML;
      content.scrollTop = 0;
      setInterval(() => {
        content.scrollTop++;
        if (content.scrollTop >= msg1.scrollHeight) {
          content.scrollTop = 0;
        }
      }, 120);
    },

    // send code
    sendCode() {
      if (!this.loginUser || this.loginUser.length < 9)
        return this.$Toast("Número de 9 dígitos");
      this.btnDisabled = true;
      this.countInterval = setInterval(() => {
        if (this.countDown == 1) {
          clearInterval(this.countInterval);
          this.countDown = 60;
          this.btnDisabled = false;
          return;
        }
        this.countDown--;
      }, 1000);
      const params = {
        loginUser: "+51" + this.loginUser,
        userType: 1,
        verifyCodeType: 8,
      };
      // 接口
      getCode(params).then(({ data }) => {
        if (data.code !== 0) {
          clearInterval(this.timeInterval);
          this.countDown = 60;
          this.btnDisabled = false;
        }
      });
    },

    detailPointData(arr, name) {
      let obj = {};
      for (let i = 0; i < arr.length; i++) {
        obj[arr[i].split("=")[0]] = arr[i].split("=")[1];
      }
      return obj[name];
    },

    // 提交
    submitRegister() {
      if (!this.loginUser || this.loginUser.length < 9)
        return this.$Toast(
          "Por favor, introduzca un número de teléfono móvil de 9 dígitos."
        );
      if (!this.auth_code)
        return this.$Toast("Por favor, introduzca el Código de verificación");

      ADINPUT("test");
      let ylurlValue = document
        .querySelector("input[name='ylurl']")
        .value.split("&");

      const params = {
        auth_code: this.auth_code,
        userType: 1,
        firebase_id: "firebase_id",
        notice_switch: 0,
        loginUser: "+51" + this.loginUser,
        af_channel: window.localStorage.getItem("channel"),
        appsflyer_id: this.detailPointData(ylurlValue, "fbc"),
        google_advertising_id: this.detailPointData(ylurlValue, "fbp"),
        ua: this.detailPointData(ylurlValue, "ua"),
      };

      // 登录
      login(params).then(({ data }) => {
        if (data.code == 0) {
          localStorage.setItem("token", data.data.access_token);
          this.$store.commit("setToken", data.data.access_token);
          this.$router.push("/home");
        } else {
        }
      });
    },

    openApp(row, mobile) {
      if (row == 2) {
        window.location.href = "tel:" + mobile;
      } else {
        this.$Toast("Se está abriendo WhatsApp...");
        window.open("https://api.whatsapp.com/send?phone=" + mobile);
      }
    },

    onCopy() {
      this.$Toast("copy Success");
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.contentBox {
  padding-bottom: 0.67rem;
  background: linear-gradient(360deg, #ffdfdf 0%, #f43839 100%);
}

.infoContent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 0.68rem;
  background: #f7f49c;
  img {
    width: 0.3rem;
    height: 0.3rem;
    margin-right: 0.1rem;
  }
  .infoList {
    height: 0.27rem;
    overflow: hidden;
    .contentBox1 {
      li {
        display: flex;
        line-height: 0.35rem;
        font-family: Roboto, Roboto;
        font-size: 0.22rem;
        color: #dd6e00;
      }
    }
  }
}

.headBanner {
  width: 100%;
  img {
    width: 100%;
  }
}

.contentBIgBox {
  width: 100%;
  padding: 0 0.26rem;
}

.title {
  font-family: Roboto, Roboto;
  font-weight: 700;
  font-size: 0.32rem;
  color: #ffffff;
  text-align: center;
  width: 4.9rem;
  margin: 0 auto 0.26rem;
}
.registerBox {
  width: 100%;
  min-height: 4.23rem;
  padding: 0.5rem 0.55rem 0.2rem;
  background: linear-gradient(
    180deg,
    #ffecec 0%,
    #ffecec 16%,
    #fff 28%,
    #ffffff 100%
  );
  border-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0)
    )
    0.04 0.04;
  border-radius: 0.3rem;
}
.van-cell {
  background-color: transparent;
  border-bottom: 0.01rem solid #cccccc;
  padding: 0.27rem 0;
}
/deep/ .van-field__label {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 0.26rem;
  color: #333333;
  width: 0.7rem !important;
}
.codeBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  width: 1.12rem;
  height: 0.38rem;
  background: #ffd451;
  border-radius: 0.19rem;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 0.2rem;
  color: #ffffff;
}
.subImg {
  display: block;
  width: 5.64rem;
  margin: 0.19rem auto 0;
}
.videoBox {
  display: block;
  width: 100%;
  border-radius: 0.3rem;
  margin-top: 0.3rem;
}
.plataformaBox {
  position: relative;
  width: 100%;
  min-height: 6.38rem;
  padding: 0.8rem 0.64rem 0.3rem 0.34rem;
  border-radius: 0.3rem;
  background: url("../../assets/images/h5Img/plataformaBgc.png") no-repeat;
  background-size: 100% 100%;
  margin: 0.3rem 0;
  ul {
    li {
      display: flex;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.24rem;
      color: #666666;
      margin-bottom: 0.2rem;
      img {
        width: 0.25rem;
        height: 0.25rem;
        margin: 0.04rem 0.14rem 0 0;
        vertical-align: text-top;
      }
    }
  }
}

.titleImg {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../../assets/images/h5Img/titleBgc.png") no-repeat;
  background-size: 100% 100%;
  width: 3.87rem;
  height: 0.53rem;
  font-family: Roboto, Roboto;
  font-weight: 500;
  font-size: 0.26rem;
  color: #ffffff;
}

.datosPlataforma {
  position: relative;
  width: 100%;
  height: 3.91rem;
  border-radius: 0.3rem;
  background: url("../../assets/images/h5Img/datosBgc.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 0.9rem;
  ul {
    li {
      padding-left: 0.46rem;
      margin: 0 auto;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 0.23rem;
      color: #666666;
      margin-bottom: 0.2rem;
    }
  }
}

.concatBox {
  position: relative;
  width: 100%;
  min-height: 3.57rem;
  background: linear-gradient(180deg, #ffe5e5 0%, #ffffff 30%, #ffffff 100%);
  border-radius: 0.3rem;
  border: 0.04rem solid #fff;
  margin-top: 0.3rem;
  .titleImg {
    width: 3.01rem;
    height: 0.53rem;
    background: url("../../assets/images/h5Img/titleBgc.png") no-repeat;
    background-size: 100% 100%;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.26rem;
    color: #ffffff;
  }
  ul {
    padding: 0 0.4rem;
    margin-top: 0.96rem;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.45rem;
      div {
        display: flex;
        align-items: center;
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.24rem;
        color: #666666;
        img {
          margin-right: 0.1rem;
          width: 0.4rem;
          height: 0.4rem;
        }
      }
      p {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 0.24rem;
        color: #666666;
      }
    }
  }
}
</style>
